<div class="container-fluid mt-24">
  <div class="row">
    <div class="col-auto p-0" style="display: flex;">
      <div class="dropdown">
        <button class="btn-1 btn-dropdown" type="button" id="samplingDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="max-width-200">{{isControlFields?'Control '+(controlFieldType==DeploymentType.Deployment?'Field':controlFieldType)
            :deploymentType}}</div>
          <img src="../../../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
        </button>
        <div class="dropdown-menu" aria-labelledby="samplingDropdown" style="width:13rem;">
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.Deployment)">
            {{DeploymentType.Deployment}}
          </button>
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.PreSampling)">
            {{DeploymentType.PreSampling}}
            <div class="phase-pointer" style="background: #E39217;"></div>
          </button>
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.StartSample)">
            {{DeploymentType.StartSample}}
            <div class="phase-pointer" style="background: #1F78C1;"></div>
          </button>
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.HarvestSample)">
            {{DeploymentType.HarvestSample}}
            <div class="phase-pointer" style="background: #FFA17A;"></div>
          </button>
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.EndYearSample)">
            {{DeploymentType.EndYearSample}}
            <div class="phase-pointer" style="background: #7163B4;"></div>
          </button>
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.End3rdYearSample)">
            {{DeploymentType.End3rdYearSample}}
            <div class="phase-pointer" style="background: #F97DEA;"></div>
          </button>
          <button class="dropdown-item" (click)="setDeploymentType(DeploymentType.End5thYearSample)">
            {{DeploymentType.End5thYearSample}}
            <div class="phase-pointer" style="background: #825500;"></div>
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.Deployment)">
            Control Field
            <!-- {{DeploymentType.Deployment}} -->
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.PreSampling)">
            Control {{DeploymentType.PreSampling}}
            <div class="phase-pointer" style="background: #E39217;"></div>
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.StartSample)">
            Control {{DeploymentType.StartSample}}
            <div class="phase-pointer" style="background: #1F78C1;"></div>
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.HarvestSample)">
            Control {{DeploymentType.HarvestSample}}
            <div class="phase-pointer" style="background: #FFA17A;"></div>
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.EndYearSample)">
            Control {{DeploymentType.EndYearSample}}
            <div class="phase-pointer" style="background: #7163B4;"></div>
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.End3rdYearSample)">
            Control {{DeploymentType.End3rdYearSample}}
            <div class="phase-pointer" style="background: #F97DEA;"></div>
          </button>
          <button class="dropdown-item" (click)="setControlFieldType(DeploymentType.End5thYearSample)">
            Control {{DeploymentType.End5thYearSample}}
            <div class="phase-pointer" style="background: #825500;"></div>
          </button>
        </div>
      </div>
      <div class="dropdown ml-16">
        <button class="btn-1 btn-dropdown" type="button" id="approvalNeed" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="max-width-200">{{progressType|titlecase}}</div>
          <img src="../../../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
        </button>
        <div class="dropdown-menu" aria-labelledby="approvalNeed">
          <button class="dropdown-item" (click)="setProgress(ProgressType.approved)">{{ProgressType.approved|titlecase}}</button>
          <button class="dropdown-item" (click)="setProgress(ProgressType.rejected)">{{ProgressType.rejected|titlecase}}</button>
          <button class="dropdown-item" (click)="setProgress(ProgressType.pending)">{{ProgressType.pending|titlecase}}</button>
        </div>
      </div>
    </div>
    <div class="col-auto ml-auto p-0" style="display: flex;">
      <div class="dropdown">
        <button class="btn-1 btn-dropdown" type="button" id="locationDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span *ngIf="selectedVillage.villageId == -1">Location</span>
          <span *ngIf="selectedVillage.villageId != -1">{{selectedVillage.villageName}}</span>
          <img src="../../../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
        </button>
        <div class="dropdown-menu" aria-labelledby="locationDropdown">
          <div class="custom-filter-search">
            <img src="../../../../../assets/images/search-icon-1.svg" alt="search-icon-1" width="24px" height="24px" class="search-1">
            <input type="text" [(ngModel)]="villageFilterSearch" placeholder="Search" class="max-width-200">
          </div>
          <button class="dropdown-item" (click)="$event.stopPropagation();allSelectedVillage = !allSelectedVillage;onToggleAllVillage()" >
            <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="18px" height="18px" 
             class="mr--8" *ngIf="!allSelectedVillage">
            <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="18px" height="18px" 
             class="mr--8"  *ngIf="allSelectedVillage">
            <div class="overflow-hidden-200">All</div>
          </button>
          <ng-container *ngFor="let item of villageList|searchFilter:villageFilterSearch">
            <button class="dropdown-item" (click)="$event.stopPropagation();item.flag = !item.flag;onFilterVillage()" >
              <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="18px" height="18px" 
               class="mr--8" *ngIf="!item.flag">
              <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="18px" height="18px" 
               class="mr--8"  *ngIf="item.flag">
              <div class="max-width-200">{{item.villageName}}</div>
            </button>
            <!-- <button class="dropdown-item" (click)="setVillage(item.villageId)">{{item.villageName}}</button> -->
          </ng-container>
        </div>
      </div>
      <div class="ml-16"> 
        <app-date-range-picker></app-date-range-picker>
      </div>
      <!-- <div class="dropdown ml-16">
        <input type="date" [(ngModel)]="startDateValue" (change)="onChangeStartDate()">
      </div>
      <div class="dropdown ml-16">
        <input type="date" [(ngModel)]="endDateValue" (change)="onChangeEndDate()">
      </div> -->
    </div>
  </div>
</div>
<div class="container-fluid mt-16">
  <div class="row">
      <div class="col-5 pl-0 table-block-1" style="position:relative;">
        <table class="table">
            <thead>
              <tr>
                <ng-container *ngIf="isControlFields">
                  <th scope="col">
                      <button class="btn-1 btn-no-border p-0" *ngIf="allControlFieldData" (click)="toggleAllControlFieldData()">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!allControlFieldData" (click)="toggleAllControlFieldData()">
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                  </th>
                  <th scope="col">Sl no.</th>
                  <th scope="col" (click)="sortControlFieldData1('farmerName')" class="cursor-pointer">Farmer name</th>
                  <th scope="col" *ngIf="controlFieldType != DeploymentType.Deployment"
                  (click)="sortDeploymentData1('noPreSamples')" class="cursor-pointer">Samples</th>
                  <th scope="col" *ngIf="controlFieldType == DeploymentType.Deployment">Area</th>
                  <th scope="col" *ngIf="!fromDashboard && progressType != ProgressType.approved">Action</th>
                </ng-container>
                <ng-container *ngIf="!isControlFields">
                  <th scope="col">
                      <button class="btn-1 btn-no-border p-0" *ngIf="allDeploymentData1" (click)="toggleAllDeploymentData1()">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!allDeploymentData1" (click)="toggleAllDeploymentData1()">
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                  </th>
                  <th scope="col">Sl no.</th>
                  <th scope="col" (click)="sortDeploymentData1('farmerName')" class="cursor-pointer">Farmer name</th>
                  <th scope="col" *ngIf="deploymentType != DeploymentType.Deployment"
                  (click)="sortDeploymentData1('noPreSamples')" class="cursor-pointer">Samples</th>
                  <th scope="col" *ngIf="deploymentType == DeploymentType.Deployment">Area</th>
                  <th scope="col" *ngIf="deploymentType == DeploymentType.Deployment">Calculated Area</th>
                  <th scope="col" *ngIf="deploymentType == DeploymentType.Deployment">NOC</th>
                  <th scope="col" *ngIf="!fromDashboard && progressType != ProgressType.approved">Action</th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="!isControlFields">
                  <ng-container *ngFor="let item of deploymentData1;let i=index">
                    <tr *ngIf="item.enable" (click)="item.flag = !item.flag;getSampleDetails()" class="cursor-pointer">
                        <td>
                            <button class="btn-1 btn-no-border p-0" *ngIf="item.flag">
                              <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                            </button>
                            <button class="btn-1 btn-no-border p-0" *ngIf="!item.flag">
                                <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                            </button>
                        </td>
                        <td>
                          {{i+1}}
                        </td>
                        <td>
                          {{item.farmerName}}
                        </td>
                        <td *ngIf="deploymentType == DeploymentType.PreSampling">
                          {{item?.noPreSamples}}
                        </td>
                        <td *ngIf="deploymentType != DeploymentType.PreSampling
                        && deploymentType != DeploymentType.Deployment">
                          {{item?.noInitialSamples}}
                        </td>
                        <td *ngIf="deploymentType == DeploymentType.Deployment">
                          {{item?.calculatedArea|number:'1.0-2'}}
                        </td>
                        <td *ngIf="deploymentType == DeploymentType.Deployment">
                          {{item?.actualArea|number:'1.0-2'}}
                        </td>
                        <td *ngIf="deploymentType == DeploymentType.Deployment">
                          <span class="underline-btn" data-toggle="modal" data-target="#viewImageAction" 
                          (click)="samplePicture=item?.noc;setSelectedFarmer(item);">
                            View
                          </span>
                        </td>
                        <td *ngIf="!fromDashboard && progressType != ProgressType.approved">
                          <div class="content-center">
                            <button class="btn-1 circle-btn fill-red-btn" [disabled]="!item.flag" 
                            *ngIf="item.progressFlag && progressType != ProgressType.rejected" 
                            (click)="$event.stopPropagation();onCloseParticularReport(item.farmerId)">
                              <img src="../../../../../assets/images/cross-icon-2.svg" alt="cross-icon" width="16px" height="16px">
                            </button>
                            <button class="btn-1 circle-btn red-border" [disabled]="!item.flag" (click)="$event.stopPropagation();onRejectFarmer(item)" 
                            *ngIf="!item.progressFlag && progressType != ProgressType.rejected">
                              <img src="../../../../../assets/images/cross-icon.svg" alt="cross-icon" width="16px" height="16px">
                            </button>
                            <button class="btn-1 ml-24 circle-btn green-border" [disabled]="!item.flag || !farmEditAccess" 
                            (click)="onAcceptFarmer(item)" *ngIf="!item.progressFlag">
                              <img src="../../../../../assets/images/tick-icon.svg" alt="tick-icon" width="16px" height="16px">
                            </button>
                          </div>
                        </td>
                    </tr>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isControlFields">
                  <ng-container *ngFor="let item of controlFieldList;let i=index">
                    <tr *ngIf="item.enable" (click)="item.flag = !item.flag;onSelectControlField(item.farmerId)" class="cursor-pointer">
                      <td>
                          <button class="btn-1 btn-no-border p-0" *ngIf="item.flag">
                            <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                          </button>
                          <button class="btn-1 btn-no-border p-0" *ngIf="!item.flag">
                              <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                          </button>
                      </td>
                        <td>
                          {{i+1}}
                        </td>
                        <td>
                          {{item.farmerName}}
                        </td>
                        <td *ngIf="controlFieldType == DeploymentType.Deployment">
                          {{item.controlArea}}
                        </td>
                        <td *ngIf="controlFieldType != DeploymentType.Deployment">
                          {{item.sampleCount}}
                        </td>
                        <td *ngIf="!fromDashboard && progressType != ProgressType.approved">
                          <div class="content-center">
                            <button class="btn-1 circle-btn fill-red-btn" [disabled]="!item.flag" 
                            *ngIf="item.progressFlag && progressType != ProgressType.rejected" 
                            (click)="$event.stopPropagation();onCloseParticularControlFieldReport(item.farmerId)">
                              <img src="../../../../../assets/images/cross-icon-2.svg" alt="cross-icon" width="16px" height="16px">
                            </button>
                            <button class="btn-1 circle-btn red-border" [disabled]="!item.flag" (click)="$event.stopPropagation();onRejectControlField(item)" 
                            *ngIf="!item.progressFlag && progressType != ProgressType.rejected">
                              <img src="../../../../../assets/images/cross-icon.svg" alt="cross-icon" width="16px" height="16px">
                            </button>
                            <button class="btn-1 ml-24 circle-btn green-border" [disabled]="!item.flag || !farmEditAccess" 
                            (click)="onAcceptControlField(item)" *ngIf="!item.progressFlag">
                              <img src="../../../../../assets/images/tick-icon.svg" alt="tick-icon" width="16px" height="16px">
                            </button>
                          </div>
                        </td>
                    </tr>
                  </ng-container>
                </ng-container>
            </tbody>
        </table>
        <div class="footer-info" *ngIf="!isControlFields &&
        deploymentType == DeploymentType.Deployment">
          <div style="display:inline-flex;">
            Total area: {{totalArea| number: '1.0-2'}}
          </div>
          <div style="display:inline-flex;float:right;">
            Total tons: {{totalTons| number: '1.0-2'}}
          </div>
        </div>
      </div>
      <div class="col-7 pr-0">
        <div class="table-block-1" style="position:relative">
          <div id="myCustomMap"></div>
          <button class="map-btn" (click)="showMapMenu=!showMapMenu" [ngClass]="{'show-btn':showMapMenu}" 
          *ngIf="!fromDashboard && deploymentType == DeploymentType.Deployment">
            <img src="../../../../../assets/images/caret-icon-2.svg" alt="caret-icon" width="20px" height="20px" *ngIf="showMapMenu" style="transform: rotate(180deg);" >
            <img src="../../../../../assets/images/caret-icon-2.svg" alt="caret-icon" width="20px" height="20px" *ngIf="!showMapMenu" >
          </button>
          <div *ngIf="showMapMenu">
            <div class="card card-body map-group">
              <div class="row justify-content-around">
                <div class="col content-center">
                  <button class="btn-no-border" (click)="getGeoJsonFromMap();addControlFieldGeojson()"
                  [disabled]="!farmEditAccess">
                    <div>
                      <img src="../../../../../assets/images/add-icon.svg" alt="add-icon" width="20px" height="20px" >
                    </div>
                    <div class="map-group-label">
                      Add
                    </div>
                  </button>
                </div>
                <!-- <div class="col content-center">
                  <button class="btn-no-border">
                    <div>
                      <img src="../../../../../assets/images/undo-icon.svg" alt="undo-icon" width="20px" height="20px" >
                    </div>
                    <div class="map-group-label">
                      Undo
                    </div>
                  </button>
                </div>
                <div class="col content-center">
                  <button class="btn-no-border">
                    <div>
                      <img src="../../../../../assets/images/redo-icon.svg" alt="redo-icon" width="20px" height="20px" >
                    </div>
                    <div class="map-group-label">
                      Redo
                    </div>
                  </button>
                </div> -->
                <div class="col content-center">
                  <button class="btn-no-border" (click)="clearAllPolygon()">
                    <div>
                      <img src="../../../../../assets/images/cancel-icon.svg" alt="cross-icon" width="20px" height="20px" >
                    </div>
                    <div class="map-group-label">
                      Clear all
                    </div>
                  </button>
                </div>
                <div class="col content-center">
                  <button class="btn-no-border" (click)="deleteSelectedPolygon()">
                    <div>
                      <img src="../../../../../assets/images/cancel-icon.svg" alt="cross-icon" width="20px" height="20px" >
                    </div>
                    <div class="map-group-label">
                      Delete Selected
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <button (click)="createPolygon()" class="btn-1 create-shape-fill">create polygon</button>
          <button (click)="clearMap()" class="btn-1 create-shape-fill side-btn ml--4">clear</button> -->
        </div>
      </div>
  </div>
</div>
<div class="container-fluid table-block-2 mt-16" style="position:relative;">
<!-- <ng-container  *ngIf="controlFieldList && controlFieldList.length>0">
  <div class="container-fluid mt-16">
    <div class="row">
      <div class="col txt-18-22 p-0">
        Comparison data
      </div>
    </div>
  </div>
  <div class="container-fluid mt-16 comparison-tab-wrapper"
  *ngFor="let item of controlFieldList">
    <div class="item">
      <label>Farmer name:</label>
      <span class="txt-1">{{item.farmerName}}</span>
    </div>
    <div class="item">
      <label>Control plot id:</label>
      <span class="txt-1">{{item.plotIdReadable}}</span>
    </div>
    <div class="item">
      <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
        <button class="btn-1 btn-no-border p-0" *ngIf="item.isLocationReported" (click)="item.isLocationReported= false">
          <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
        </button>
        <button class="btn-1 btn-no-border p-0" *ngIf="!item.isLocationReported" (click)="item.isLocationReported= true">
            <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
        </button>
      </div>
      <label>Location:</label>
      <span class="txt-1 underline-btn" (click)="viewLocation(item.location)" 
      [ngClass]="{'danger':item.isLocationReported && progressType == ProgressType.rejected}">View</span>
    </div>
    <ng-container *ngIf="deploymentType == DeploymentType.Deployment">
      <div class="item">
        <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
          <button class="btn-1 btn-no-border p-0" *ngIf="item.isAreaReported" (click)="item.isAreaReported= false">
            <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
          </button>
          <button class="btn-1 btn-no-border p-0" *ngIf="!item.isAreaReported" (click)="item.isAreaReported= true">
              <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
          </button>
        </div>
        <label>Area:</label>
        <span class="txt-1"
        [ngClass]="{'danger':item.isAreaReported && progressType == ProgressType.rejected}">{{item.calculatedArea || '-'}}</span>
      </div>
      <div class="item">
        <label>Calculated Area:</label>
        <span class="txt-1">{{item.calculatedArea || '-'}}</span>
      </div>
      <div class="item">
        <label>Delete Shape file:</label>
        <span class="txt-1 btn-no-border danger underline cursor-pointer"
        (click)="onDeleteShapeFileForControlField(item.controlFieldId)">Delete</span>
      </div>
    </ng-container>
    <ng-container *ngIf="deploymentType != DeploymentType.Deployment">
      <div class="item">
        <label>Date of collection:</label>
        <span class="txt-1">{{item.date}}</span>
      </div>
      <div class="item">
        <div *ngIf="reportState&& isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
          <button class="btn-1 btn-no-border p-0" *ngIf="item.isSampleIdReported" (click)="item.isSampleIdReported= false">
            <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
          </button>
          <button class="btn-1 btn-no-border p-0" *ngIf="!item.isSampleIdReported" (click)="item.isSampleIdReported= true">
              <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
          </button>
        </div>
        <label>Sample ID:</label>
        <span class="txt-1 underline-btn" data-toggle="modal" data-target="#viewImage" 
        (click)="samplePicture = item.picture"
        [ngClass]="{'danger':item.isSampleIdReported && progressType == ProgressType.rejected}">{{item.sampleId}}</span> 
      </div>
    </ng-container>
    <div class="item">
      <label>Surveyor:</label>
      <span class="txt-1 underline-btn" data-toggle="modal" data-target="#surveyorDetails" 
      (click)="surveyorName=item.surveyorName;surveyorPhone=item.surveyorNumber">
      {{item.surveyorName}}</span>
    </div>
    <div class="item">
      <label>Comment:</label>
      <span class="txt-1 underline-btn" data-toggle="modal" data-target="#commentModal" 
      (click)="commentObj={comment:item.comment,id:item.farmerId,sampleId:item.sampleId}">
        {{item.comment && item.comment.length>0?'View':'Add'}}
      </span>
    </div>
  </div>
</ng-container> -->

<ng-container *ngIf="isControlFields">
  <div class="row">
    <div class="col-12 p-0">
      <table class="table">
        <thead>
          <tr *ngIf="controlFieldType == DeploymentType.Deployment">
              <th scope="col">Farmer name</th>
              <th scope="col">Plot id</th>
              <th scope="col">Location</th>
              <th scope="col">Date of collection</th>
              <th scope="col">Area</th>
              <th scope="col">Calculated Area</th>
              <th scope="col">Shape File</th>
              <th scope="col">Surveyor</th>
              <th scope="col">Comment</th>
          </tr>
          <tr *ngIf="controlFieldType != DeploymentType.Deployment">
            <th scope="col">Farmer name</th>
            <th scope="col">Plot id</th>
            <th scope="col">Location</th>
            <th scope="col">Date of collection</th>
            <th scope="col">Sample Id</th>
            <th scope="col">Surveyor</th>
            <th scope="col">Comment</th>
          </tr>
        </thead>
        <tbody>
          <ng-container  *ngFor="let item of selectedControlFieldList">
            <ng-container >
              <tr>
                <td>
                  <span class="txt-1">{{item.farmerName}}</span>
                </td>
                <td>
                  <span class="txt-1">{{item.plotIdReadable}}</span>
                </td>
                <td>
                  <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                    <button class="btn-1 btn-no-border p-0" *ngIf="item.isLocationReported" (click)="item.isLocationReported= false">
                      <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                    </button>
                    <button class="btn-1 btn-no-border p-0" *ngIf="!item.isLocationReported" (click)="item.isLocationReported= true">
                        <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                    </button>
                  </div>
                  <span class="txt-1 underline-btn" (click)="viewLocation(item.location)" 
                  [ngClass]="{'danger':item.isLocationReported && progressType == ProgressType.rejected}">View</span>
                </td>
                <td>
                  <span class="txt-1">{{item.date|date:'dd/MM/yyyy'}}</span>
                </td>
                <ng-container *ngIf="controlFieldType == DeploymentType.Deployment">
                  <td>
                    <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                      <button class="btn-1 btn-no-border p-0" *ngIf="item.isAreaReported" (click)="item.isAreaReported= false">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!item.isAreaReported" (click)="item.isAreaReported= true">
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                    </div>
                    <span class="txt-1"
                    [ngClass]="{'danger':item.isAreaReported && progressType == ProgressType.rejected}">{{item.controlArea || '-'}}</span>
                  </td>
                  <td>
                    <span class="txt-1">{{item.calculatedArea || '-'}}</span>
                  </td>
                  <td>
                    <span class="txt-1 btn-no-border danger underline cursor-pointer"
                    (click)="onDeleteShapeFileForControlField(item.controlFieldId)">Delete</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="controlFieldType != DeploymentType.Deployment">
                  <td>
                    <div *ngIf="reportState&& isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                      <button class="btn-1 btn-no-border p-0" *ngIf="item.isSampleIdReported" (click)="item.isSampleIdReported= false">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!item.isSampleIdReported" (click)="item.isSampleIdReported= true">
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                    </div>
                    <span class="txt-1 underline-btn" data-toggle="modal" data-target="#viewImage" 
                    (click)="samplePicture = item.picture"
                    [ngClass]="{'danger':item.isSampleIdReported && progressType == ProgressType.rejected}">{{item.sampleCode}}</span> 
                  </td>
                </ng-container>
                <td>
                  <span class="txt-1 underline-btn" data-toggle="modal" data-target="#surveyorDetails" 
                  (click)="surveyorName=item.surveyorName;surveyorPhone=item.surveyorNumber">
                  {{item.surveyorName}}</span>
                </td>
                <td>
                  <span class="txt-1 underline-btn" data-toggle="modal" data-target="#commentModal" 
                  (click)="commentObj={comment:item.comment,id:item.farmerId,sampleId:item.sampleId}">
                    {{item.comment && item.comment.length>0?'View':'Add'}}
                  </span>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
<div class="row"  *ngIf="!isControlFields">
    <div class="col-12 p-0">
      <table class="table">
          <thead>
          <tr *ngIf="deploymentType != DeploymentType.Deployment">
              <th scope="col">Farmer name</th>
              <th scope="col">Plot id</th>
              <th scope="col">Date of collection</th>
              <th scope="col">Location</th>
              <th scope="col">Sample ID</th>
              <th scope="col">Surveyor</th>
              <th scope="col">Comment</th>
              <th scope="col" *ngIf="fromDashboard">Verified by</th>
          </tr>
          <tr *ngIf="deploymentType == DeploymentType.Deployment">
              <th scope="col" colspan="2" >Trailer reg. no</th>
              <th scope="col" colspan="2">Village</th>
              <th scope="col" colspan="2" *ngIf="fromDashboard">Source name</th>
              <th scope="col" *ngIf="!fromDashboard">Source name</th>
              <th scope="col">No. of plots</th>
              <th scope="col" colspan="2" *ngIf="!fromDashboard">Video</th>
              <th scope="col" *ngIf="fromDashboard">Video</th>
              <th scope="col">Surveyor</th>
          </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="deploymentType != DeploymentType.Deployment && sectionDetails && sectionDetails.length>0">
              <ng-container *ngFor="let item of sectionDetails">
                <tr *ngIf="item.sampleId">
                  <td>
                    {{item.farmerName}}
                  </td>
                  <td *ngIf="item.plotId">
                    {{item.plotId}}
                  </td>
                  <td *ngIf="!item.plotId">
                    --
                  </td>
                  <td *ngIf="item.date">
                    {{item.date}}
                  </td>
                  <td *ngIf="!item.date">
                    --
                  </td>
                  <td>
                    <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                      <button class="btn-1 btn-no-border p-0" *ngIf="item.isLocationReported" (click)="item.isLocationReported= false">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!item.isLocationReported" (click)="item.isLocationReported= true">
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                    </div>
                    <span (click)="viewLocation(item.sampleLocation)" class="underline-btn" 
                    [ngClass]="{'danger':item.isLocationReported && progressType == ProgressType.rejected}">
                      View
                    </span>
                  </td>
                  <td>
                    <div *ngIf="reportState&& isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                      <button class="btn-1 btn-no-border p-0" *ngIf="item.isSampleIdReported" (click)="item.isSampleIdReported= false">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!item.isSampleIdReported" (click)="item.isSampleIdReported= true">
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                    </div>
                    <span class="underline-btn" data-toggle="modal" data-target="#viewImage" 
                    (click)="samplePicture = item.picture"
                    [ngClass]="{'danger':item.isSampleIdReported && progressType == ProgressType.rejected}">
                    {{extractSampleId(item.sampleId)}}
                    </span>
                  </td>
                  <td>
                    <span class="underline-btn" data-toggle="modal" data-target="#surveyorDetails" 
                    (click)="surveyorName=item.surveyorName;surveyorPhone=item.phoneNo">
                    {{item.surveyorName}}
                    </span>
                  </td>
                  <td>
                    <span class="underline-btn" data-toggle="modal" data-target="#commentModal" 
                    (click)="commentObj={comment:item.comment,id:item.farmerId,sampleId:item.sampleId}">
                      {{item.comment && item.comment.length>0?'View':'Add'}}
                    </span>
                  </td>
                  <td *ngIf="fromDashboard">
                    <span *ngIf="item.verifierName">{{item.verifierName}}</span>
                    <span *ngIf="!item.verifierName">-</span>
                  </td>
                  <!-- <td>
                      <button class="btn-1 btn-no-border p-0" *ngIf="item.flag" (click)="item.flag = !item.flag">
                        <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                      <button class="btn-1 btn-no-border p-0" *ngIf="!item.flag" (click)="item.flag = !item.flag" >
                          <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                      </button>
                  </td> -->
                </tr>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="deploymentType == DeploymentType.Deployment && deploymentNewSection && deploymentNewSection.length>0 ">
              <ng-container  *ngFor="let item of deploymentNewSection">
                <tr (click)="onSelectTrailer2(item)" class="cursor-pointer">
                  <td colspan="2">
                    {{item.trailerNo}}
                  </td>
                  <td colspan="2">
                    {{item.villageName}}
                  </td>
                  <td colspan="2" *ngIf="fromDashboard">
                    {{item.sourceName}}
                  </td>
                  <td *ngIf="!fromDashboard">
                    {{item.sourceName}}
                  </td>
                  <td *ngIf="item.numPlotsUnload">
                    {{item.numPlotsUnload}}
                  </td>
                  <td *ngIf="!item.numPlotsUnload">
                    0
                  </td>
                  <td colspan="2" *ngIf="!fromDashboard" class="overflow-hidden-200">
                    <span class="underline-btn" data-toggle="modal" data-target="#videoPlayer" 
                    (click)="videoSource=item.video"  *ngIf="item.video">
                    link
                    </span>
                    <span *ngIf="!item.video">-</span>
                  </td>
                  <td  *ngIf="fromDashboard" class="overflow-hidden-200">
                    <span class="underline-btn" data-toggle="modal" data-target="#videoPlayer" 
                    (click)="videoSource=item.video"  *ngIf="item.video">
                    link
                    </span>
                    <span *ngIf="!item.video">-</span>
                  </td>
                  <td>
                    <span class="underline-btn" data-toggle="modal" data-target="#surveyorDetails" 
                    (click)="surveyorName=item.surveyorName;surveyorPhone=item.surveyorRegistredNo">
                    {{item.surveyorName}}
                    </span>
                  </td>
                </tr>
                <ng-container *ngIf="selectedTrailer == item.trailerNo && selectedDispatch == item.dispatchId">
                  <tr class="trailer-header">
                      <th scope="col">Plot id</th>
                      <th scope="col">Location</th>
                      <th scope="col">MATI deployed</th>
                      <th scope="col">Area</th>
                      <th scope="col">Calculated Area</th>
                      <th scope="col">Date of deployment</th>
                      <th scope="col">Picture</th>
                      <!-- <th scope="col">Pre sample field</th> -->
                      <th scope="col" *ngIf="!fromDashboard">Shape file</th>
                      <th scope="col" *ngIf="fromDashboard">Verified by</th>
                      <th scope="col">Comment</th>
                  </tr>
                  <ng-container  *ngFor="let item of trailerDetails;">
                    <tr class="trailer-info" *ngIf="item.repeaterFormId">
                      <td>
                        {{item.plotId}}
                      </td>
                      <td>
                        <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                          <button class="btn-1 btn-no-border p-0" *ngIf="item.isLocationReported" (click)="item.isLocationReported= false">
                            <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                          </button>
                          <button class="btn-1 btn-no-border p-0" *ngIf="!item.isLocationReported" (click)="item.isLocationReported= true">
                              <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                          </button>
                        </div>
                        <span (click)="viewLocation(item.location)" class="underline-btn" 
                        [ngClass]="{'danger':item.isLocationReported && progressType == ProgressType.rejected}">
                          View
                        </span>
                      </td>
                      <td>
                        <div *ngIf="reportState && isParentInProgress(item.farmerId)" style="display: inline-flex; margin-right: 2.5px;">
                          <button class="btn-1 btn-no-border p-0" *ngIf="item.isMatiDeployed" (click)="item.isMatiDeployed= false">
                            <img src="../../../../../assets/images/check-box-on.svg" alt="check-box-off" width="24px" height="24px" >
                          </button>
                          <button class="btn-1 btn-no-border p-0" *ngIf="!item.isMatiDeployed" (click)="item.isMatiDeployed= true">
                              <img src="../../../../../assets/images/check-box-off.svg" alt="check-box-off" width="24px" height="24px" >
                          </button>
                        </div>
                        <span *ngIf="fromDashboard" 
                        [ngClass]="{'danger':item.isMatiDeployed && progressType == ProgressType.rejected}">
                          {{item.amtPlotDeploy|number:'1.0-2'}}
                        </span>
                        <span (click)="setSelectedPlot(item)" class="underline-btn" data-toggle="modal" data-target="#changeMatiDeployed" *ngIf="!fromDashboard">
                          {{item.amtPlotDeploy|number:'1.0-2'}}
                        </span>
                      </td>
                      <td>
                        <span *ngIf="item.area">{{item.area|number:'1.0-2'}}</span>
                        <span *ngIf="!item.area">-</span>
                      </td>
                      <td>
                        <span *ngIf="item.area">{{item.calculatedArea|number:'1.0-2'}}</span>
                        <span *ngIf="!item.area">-</span>
                      </td>
                      <td>
                        {{item.date}}
                      </td>
                      <td>
                        <span class="underline-btn" data-toggle="modal" data-target="#viewImage" 
                        (click)="samplePicture = item.pictureDeployment">
                          View
                        </span>
                      </td>
                      <!-- <td>
                        
                        <div class="dropdown ml-16">
                          <button class="btn-1 btn-no-border" type="button" id="approvalNeed" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          [disabled]="fromDashboard" style="opacity:initial;">
                            <div class="max-width-200" style="color: #009FF6 !important;">
                              <span *ngIf="item.isPreSamplePlot==null"> Select an option </span>
                              <span *ngIf="item.isPreSamplePlot">Yes</span>
                              <span *ngIf="item.isPreSamplePlot == false">No</span>
                              <img src="../../../../../assets/images/caret-icon.svg" alt="caret-icon" width="16px" height="16px" >
                            </div>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="approvalNeed">
                            <button class="dropdown-item" (click)="setSelectedPlot(item);onUpdatePresamplefield(true)">Yes</button>
                            <button class="dropdown-item" (click)="setSelectedPlot(item);onUpdatePresamplefield(false)">No</button>
                          </div>
                        </div>
                      </td> -->
                      <td *ngIf="item.geometry && !fromDashboard">
                        <button class="btn-1 btn-no-border danger underline" (click)="setSelectedPlot(item);onDeletePolygon()"
                        [disabled]="!farmEditAccess">Delete</button>
                      </td>
                      <td *ngIf="!item.geometry && !fromDashboard">
                        -
                      </td>
                      <td *ngIf="fromDashboard">
                        {{item.verifierName}}
                      </td>
                      <td>
                        <span class="underline-btn" data-toggle="modal" data-target="#commentModal" 
                        (click)="commentObj={comment:item.comment,id:item.deploymentId}">
                        {{item.comment && item.comment.length>0?'View':'Add'}}
                        </span>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="(sectionDetails && sectionDetails.length ==0) && (deploymentNewSection && deploymentNewSection.length==0)">
              <tr>
                <td colspan="8" *ngIf="deploymentType != DeploymentType.Deployment && fromDashboard">
                  Please select a farmer from above table
                </td>
                <td colspan="7" *ngIf="deploymentType != DeploymentType.Deployment && !fromDashboard">
                  Please select a farmer from above table
                </td>
                <td colspan="10" *ngIf="deploymentType == DeploymentType.Deployment">
                  Please select a farmer from above table
                </td>
              </tr>
            </ng-container>
          </tbody>
      </table>
    </div>
</div>
<div class="row float-bottom" *ngIf="reportState">
  <div class="col-auto">
    <button class="btn-1 border-btn" (click)="onCloseReport()">Close</button>
  </div>
  <div class="col-auto ml-auto">
    <button class="btn-1 danger-btn"
    [disabled]="!farmEditAccess"  data-toggle="modal" data-target="#reasonModal">Report</button>
  </div>
</div>
<!-- <div class="row float-bottom" *ngIf="reportState" style="right: 16px;">
</div> -->
</div>

<app-surveyor-details [surveyorName]="surveyorName" [surveyorPhone]="surveyorPhone" ></app-surveyor-details>

<!--  surveyor details modal -->
<!-- <div class="modal fade" id="surveyorDetails" tabindex="-1" role="dialog" aria-labelledby="surveyorDetails" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
<div class="modal-dialog" role="document" style="width:400px; height:280px;">
  <div class="modal-content" style="height: 280px;">
    <div class="modal-header">
      <div class="row">
        <div class="col-12">
          Surveyor details
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 details content-start">
          <span class="text-1">Name: {{surveyorName}}</span>
        </div>
        <div class="col-12 details content-start mt-8">
          <span class="text-1">Phone no.: {{surveyorPhone}}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-auto ml-auto">
          <button type="button" class="btn-1 no-border-btn" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div> -->

<!--  surveyor details modal -->
<app-view-doc-modal [samplePicture]="samplePicture" ></app-view-doc-modal>
<app-video-player [videoSource]="videoSource" ></app-video-player>
<app-action-doc-modal [samplePicture]="samplePicture" (onRejectDocHandler)="onRejectDocNew($event)" 
(onAcceptDocHandler)="onAcceptDoc($event)" [editAccess]="farmEditAccess" ></app-action-doc-modal>
<!-- <div class="modal fade" id="viewImage" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
<div class="modal-dialog" role="document" style="width:400px; height:280px;">
  <div class="modal-content" style="height: 280px;">
    <div class="modal-body">
      <div class="row">
        <div class="col-12 details content-start content-center">
          <img [src]="samplePicture" alt="sample-picture" class="img-fluid" style="height: 260px;">
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-auto ml-auto">
          <button type="button" class="btn-1 no-border-btn" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div> -->

<!--  disqualification reason modal -->
<div class="modal fade" id="changeMatiDeployed" tabindex="-1" role="dialog" aria-labelledby="changeMatiDeployed" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
<div class="modal-dialog" role="document" style="width:400px; height:280px;">
  <div class="modal-content" style="height: 280px;">
    <div class="modal-header">
      <div class="row">
        <div class="col-12">
          MATI deployed
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div>
          <div class="form-group mt-8">
            <label for="in-table" class="lable">In table</label>
            <input class="custom-input" id="in-table"  type="text" readonly [value]="selectedPlot.oldAmtPlotDeploy" style="opacity: inherit;">
          </div>
          <div class="form-group mt-16">
            <label for="update-with" class="lable">Update with</label>
            <input type="number" class="custom-input" id="update-with" placeholder="Enter updated value here . . ." [(ngModel)]="selectedPlot.amtPlotDeploy" >
            <small id="update-with" *ngIf="selectedPlot.amtPlotDeploy <= 0" class="error">
              Please provide a valid value.
            </small>
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-auto">
          <button type="button" class="btn-1 no-border-btn" data-dismiss="modal">Cancel</button>
        </div>
        <div class="col-auto ml-auto">
          <button type="button" class="btn-1 solid-btn" (click)="onUpdateMatiDeployed()"
          [disabled]="!farmEditAccess">Submit</button>
          <button style="display:none;"  data-dismiss="modal" #closeDisqReason></button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!--  comment modal -->
<div class="modal fade" id="commentModal" tabindex="-1" role="dialog" aria-labelledby="commentModal" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
<div class="modal-dialog" role="document" style="width:400px; height:280px;">
  <div class="modal-content" style="height: 280px;">
    <div class="modal-header">
      <div class="row">
        <div class="col-12">
          Comment
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div>
          <div class="form-group mt-8">
            <label for="commentField" class="lable">Comment</label>
            <input class="custom-input" id="commentField"  type="text" 
            [(ngModel)]="commentObj.comment" style="opacity: inherit;">
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-auto">
          <button type="button" class="btn-1 no-border-btn" data-dismiss="modal">Cancel</button>
        </div>
        <div class="col-auto ml-auto">
          <button type="button" class="btn-1 solid-btn" (click)="setComment()" data-dismiss="modal"
          [disabled]="!farmEditAccess">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>


<!--  comment modal -->
<button style="display: none;"  #reasonModalBtn
data-toggle="modal" data-target="#reasonModal"></button>
<div class="modal fade" id="reasonModal" tabindex="-1" role="dialog" aria-labelledby="reasonModal" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
<div class="modal-dialog" role="document" style="width:400px; height:280px;">
  <div class="modal-content" style="height: 280px;">
    <div class="modal-header">
      <div class="row">
        <div class="col-12">
          Add Reason
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div>
          <div class="form-group mt-8">
            <label for="reasonField" class="lable">Reason</label>
            <input class="custom-input" id="reasonField"  type="text" 
            [(ngModel)]="reasonOnRejection" style="opacity: inherit;">
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-auto">
          <button type="button" class="btn-1 no-border-btn" data-dismiss="modal">Cancel</button>
        </div>
        <div class="col-auto ml-auto">
          <button style="display: none;" data-dismiss="modal"  #closeReasonDialog></button>
          <button type="button" class="btn-1 solid-btn"
          (click)="onReportSubmit()" [disabled]="reasonOnRejection && reasonOnRejection.length == 0"
          *ngIf="reportState">
            Submit
          </button>
          <button type="button" class="btn-1 solid-btn"
          (click)="onRejectDoc()" [disabled]="reasonOnRejection && reasonOnRejection.length == 0"
          *ngIf="!reportState">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>